import React from "react";
import LayerControls from "../LayerControls";
import NationSelector from "../NationSelector";
import PlanningMode from "../PlanningMode/PlanningMode";
import "./SubMenuBar.css";

const SubMenuBar = ({
  layers,
  toggleLayer,
  nations,
  selectedNation,
  setSelectedNation,
  plans,
  selectedPlan,
  setPlans,
  setSelectedPlan,
  allowCrossNationSelection = false,
  actions = null,
  showPlanning = true,
}) => {
  return (
    <div className="sub-menu-bar">
      <div className="sub-menu-row">
        <div className="sub-menu-section sub-menu-left">
          {!!actions && <div className="sub-menu-actions">{actions}</div>}
          <LayerControls layers={layers} toggleLayer={toggleLayer} />
        </div>
        <div className="sub-menu-section sub-menu-center">
          <NationSelector
            nations={nations}
            selectedNation={selectedNation}
            setSelectedNation={setSelectedNation}
            allowCrossNationSelection={allowCrossNationSelection}
          />
        </div>
        <div className="sub-menu-section sub-menu-right">
          {showPlanning && (
            <PlanningMode
              plans={plans}
              selectedPlan={selectedPlan}
              setPlans={setPlans}
              setSelectedPlan={setSelectedPlan}
              selectedNation={selectedNation}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default SubMenuBar;
